module.exports = "<base-modal v-model=\"coModalVisible\" icon=\"icon-newticket\" :hide-close-button=\"true\" @onRecord=\"handleSave\" :loading=\"loading\"\n  :title=\"titleModal\">\n  <v-layout column wrap>\n    <div v-text=\"textModal\"></div>\n  </v-layout>\n</base-modal>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/profile/components/profile-update-modal/template.html
// module id = w3dC
// module chunks = 0